import { memo } from 'react';

import RunsIconSVG from '@/assets/runs-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IRunsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={RunsIconSVG} {...props} />;

export const RunsIcon = memo(IRunsIcon) as typeof IRunsIcon;
